import React from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';

import DelayCard from '../components/DelayCard';
import EpisodeCard from '../components/EpisodeCard';

import './style.scss';

const SchedulePdfTiles = ({schedule, pdfSettings}) => {
    const $locale = useLocaleContext();

    if (!schedule) {
        return null;
    }
    
    return (
        <div className="pdf-schedule-tiles-list">
            {
                schedule
                    .map((episode) => (
                        <React.Fragment key={episode.id}>
                            {
                                !episode.delay
                                    ? <EpisodeCard
                                        episode={episode}
                                        pdfSettings={pdfSettings}
                                        className={episode.importantEpisode ? 'important-episode' : ''}
                                        $locale={$locale}
                                        isFullInfo={episode.importantEpisode}
                                    />
                                    : <DelayCard
                                        episode={episode}
                                        pdfSettings={pdfSettings}
                                        className={episode.importantEpisode ? 'important-episode' : ''}
                                        $locale={$locale}
                                    />
                            }
                        </React.Fragment>
                    ))
            }
        </div>
    )
};

export default SchedulePdfTiles;
